<h2>{{titleTranslation | translate}}</h2>

<mat-form-field>
  <input [(ngModel)]="title" matInput placeholder="{{'general.title' | translate}}" type="text"/>
</mat-form-field>

<div class="button-right-container">
  <button (click)="dialogRef.close()" class="ibexfusion-raised-button" mat-button>{{translations?.cancel}}</button>
  <button (click)="dialogRef.close(title)" class="ibexfusion-raised-button" mat-button>{{translations?.save}}</button>
</div>
